// removed by extract-text-webpack-plugin
module.exports = {"icon":"src-components-modules-Quote-style----icon-module---icon---1rokL alignItems-center borderRadius-circle display-flex fill-white justifyContent-center marginBottom-m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Quote/style/icon.module.css
// module id = 260
// module chunks = 33019919093843 96834539877599 171778037205648